/* global globalThis */
import axios from "axios";
const api = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/halo`,
  headers: {
    "Content-Type": "application/json",
    "X-Tenant-ID": process.env.REACT_APP_TENANT_ID,
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      const { response } = error;
      const isSessionExpired = response.headers["x-session-expired"] === "true";
      const isTokenExpired = response.headers["x-token-expired"] === "true";

      // Clear all client-side storage
      localStorage.clear();
      sessionStorage.clear();
      const cookies = document.cookie.split(";");
      for (const c of cookies) {
        document.cookie = c
          .replace(/^ +/, "")
          .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
      }

      if ("caches" in globalThis) {
        void caches.keys().then((names) => {
          for (let name of names) void caches.delete(name);
        });
      }

      // Redirect based on the type of 401
      if (isSessionExpired || isTokenExpired) {
        // For session or token expiration, show session timeout page
        localStorage.setItem("sessionExpired", "true");
        localStorage.setItem("isIdleTimeout", "false");
        globalThis.location.href = "/session-timeout";
      } else {
        // For invalid token or first-time login, go to landing page
        globalThis.location.href = "/landing";
      }
    }
    return Promise.reject(error);
  },
);

export default api;
